module.exports = __webpack_public_path__ + "img/notification.bd783f01.svg";